<script>
import { Pie, mixins } from 'vue-chartjs';
import chartMixins from '../../../mixins/charts';

const { reactiveProp } = mixins;

export default Pie.extend({
  props: ['options'],
  mixins: [reactiveProp],
  mounted() {
    this.addPlugin(chartMixins.plugins.emptyDataPlugin);
    this.renderChart(this.chartData, this.options);
  },
});
</script>



// WEBPACK FOOTER //
// AnalyticsPieChart.vue?15915a7b